import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataAccessCompanyInfosService {
  public companyInfos$ = new BehaviorSubject(null);

  public setCompanyInfos(companyInfos: {organizationId: string, accountId: string}) : void {
    this.companyInfos$.next({organizationId:companyInfos.organizationId, accountId: companyInfos.accountId });
  }
}
